import { render, staticRenderFns } from "./TopPages.vue?vue&type=template&id=c3b073fc&scoped=true&"
import script from "./TopPages.vue?vue&type=script&lang=js&"
export * from "./TopPages.vue?vue&type=script&lang=js&"
import style0 from "./TopPages.vue?vue&type=style&index=0&id=c3b073fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b073fc",
  null
  
)

export default component.exports